import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

type State = {
	enabled: boolean;
};

const DEFAULT_STATE: State = {
	enabled: false,
};

let state = Object.freeze(DEFAULT_STATE);

autoBeforeEachTest(() => {
	state = DEFAULT_STATE;
});

export const enableStreaming = (): void => {
	if (state.enabled) {
		throw new Error('Enable Streaming: Streaming already enabled');
	}

	state = { ...state, enabled: true };
};

export const isStreamingEnabled = (): boolean => {
	return state.enabled;
};
